/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 16:52:59
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-24 13:26:44
 * @FilePath: \hlweb2.0\src\pages\Home\Banner\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import "./index.scss";
import { useTranslation } from "react-i18next";
function Banner({ bannerObj, hideBanBtn }) {
  const { t } = useTranslation();
  return (
    <div
      className="home_banner_side"
      style={{ background: `url(${bannerObj.imgUrl})` }}
    >
      <div className="home_banner_con">
        <div className="banner-til">
          {t("home.banner1")}
          <br />
          {t("home.banner2")}
        </div>
      </div>
    </div>
  );
}

export default Banner;
